export enum SearchEventsEnum {
  OnsiteSearch = 'OnsiteSearch',
}

export enum SearchEventsVersionsEnum {
  '1.0.0' = '1.0.0',
}

export enum SearchTrackingTypes {
  ENTERED = 'entered',
  SUGGESTED = 'suggested',
  RECENT = 'recent',
  AUTOCOMPLETE = 'autocomplete',
  CORRECTED = 'corrected',
}
